module.exports = __webpack_public_path__ + "static/media/overdo-logo.2ea5d92d.svg";